export const languages = [
  { locale: "en-IN", label: "English (India)", native: "English" },
  { locale: "en-US", label: "English (US)", native: "English US" },
  { locale: "bn-IN", label: "Bengali", native: "বাংলা" },
  { locale: "gu-IN", label: "Gujarati", native: "ગુજરાતી" },
  { locale: "hi-IN", label: "Hindi", native: "हिन्दी" },
  { locale: "kn-IN", label: "Kannada", native: "ಕನ್ನಡ" },
  { locale: "ml-IN", label: "Malayalam", native: "മലയാളം" },
  { locale: "mr-IN", label: "Marathi", native: "मराठी" },
  { locale: "or-IN", label: "Odia", native: "ଓଡ଼ିଆ" },
  { locale: "pa-IN", label: "Punjabi", native: "ਪੰਜਾਬੀ" },
  { locale: "ta-IN", label: "Tamil", native: "தமிழ்" },
  { locale: "te-IN", label: "Telugu", native: "తెలుగు" },
];

/**
 * to send a message to Iframe parent
 * @param {"error" | "success"} type
 * @param {string} data
 */
export const postMessage = (type, data) => {
  window.parent?.postMessage?.(JSON.stringify({ type, data }), "*");
};
